module.exports = __webpack_public_path__ + "static/media/HighlightGoodOptimized.78e38209.jp2";